module.exports = __webpack_public_path__ + "static/media/Popcorn Costume.dcc15c4d.jpg";